import { KYMW00Model } from '../kymw00.model';
import { PlessViewUtilsSub } from '../pless-view-utils-sub.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from '../pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画ロックを取得する
 *
 * @export API通信成功時の処理
 * @class CatalogLockService
 * @extends {PlessResponder}
 */
@Injectable()
export class CatalogLockService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW00Model = null;
  private vo: any = null;
  private successFunction: Function = null;
  private lockType: string = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CatalogLockService
   */
  private getBodyRegist(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        FormId: this.vo.formId,
        UserId: this.vo.userId,
        AllMediumFlag: this.vo.allMediumFlag,
        CheckOnly: this.vo.checkOnly,
      }
    });
  }

  /**
 * bodyにセットする値を返す
 *
 * @private
 * @returns {PlessRequest} リクエストJSON
 * @memberof CatalogLockService
 */
  private getBodyRelease(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        FormId: this.vo.formId,
        UserId: this.vo.userId ? this.vo.userId.trim() : this.vo.userId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW00Model} model モデルクラス
   * @param {*} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof CatalogLockService
   */
  execute(model: KYMW00Model, vo: any, type: string) {
    this.model = model;
    this.vo = vo;
    if (type === model.EVENT_LOCK_CATALOG_REGIST) {
      this.lockType = 'REGIST';
      this.send('KYMW02registCatalogLock', this.getBodyRegist());
    } else if (type === model.EVENT_LOCK_CATALOG_REGIST_WITH_FORCE_RELEASE) {
      this.lockType = 'REGIST_WITH_FORCE_RELEASE';
      vo.checkOnly = 'ForceRelease';
      this.send('KYMW02registCatalogLock', this.getBodyRegist());
    } else if (type === model.EVENT_LOCK_CATALOG_RELEASE) {
      this.lockType = 'RELEASE';
      this.send('KYMW02releaseCatalogLock', this.getBodyRelease());
    } else if (type === model.EVENT_LOCK_CATALOG_CHECK) {
      this.lockType = 'CHECK';
      this.send('KYMW02registCatalogLock', this.getBodyRegist());
    }
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof CatalogLockService
   */
  success(_: any) {
    if (this.lockType === 'REGIST' || this.lockType === 'REGIST_WITH_FORCE_RELEASE') {
      // ロック登録に成功した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
    } else if (this.lockType === 'RELEASE') {
      // ロック解除に成功した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
    } else if (this.lockType === 'ReleaseAndRegist') {
      return;
    }
    if (this.vo.viewControl === true) {
      this.vo.viewHelper.setScreenMode(this.model.kymw1001Model.setScreenModeOnNowFunc(this.model.kymw1001Model.topFuncID));
    }

    if (this.vo.successFunc != null) {
      this.vo.successFunc(this.vo.successParam);
    }
  }

  /**
   * API通信失敗時処理
   *
   * @param {*} result
   * @memberof CatalogLockService
   */
  lockErrorHandler(result: any): void {
    if (this.lockType === 'REGIST') {
      // ロック登録に失敗した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, true);
      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode('true');
      }
      if (this.vo.faultFunc != null) {
        this.vo.faultFunc(this.vo.faultParam);
      }
    } else if (this.lockType === 'REGIST_WITH_FORCE_RELEASE') {
      // ロック登録に失敗した場合

      if (this.model.kymw1001Model.topFuncReadOnlyMode.toString() !== 'true') {
        // エラーメッセージ編集
        const lockedInfo: Array<string> = this.getMsgString(result.result.obj.UnlockedInfo).split(',');

        // メッセージ表示（ハンドラ：queryReleaseLockHandler)
        this.dialogService.openAlertGetMessage(
          'Q0144',
          [lockedInfo[0], lockedInfo[1]],
          (closeDetail) => {
            this.reConfirmMsg(closeDetail);
          }
        );
        return;
      } else {
        this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, true);
        if (this.vo.viewControl === true) {
          this.vo.viewHelper.setScreenMode('true');
        }
        if (this.vo.faultFunc != null) {
          if (this.vo.faultFunc != null) {
            this.vo.faultFunc(this.vo.faultParam);
          }
        }
      }
    } else if (this.lockType === 'RELEASE') {
      // ロック解除に失敗した場合
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);
      if (this.vo.faultFunc != null) {
        this.vo.faultFunc(this.vo.faultParam);
      }
    }
  }

  private reConfirmMsg(closeResult: number): void {
    if (closeResult === PlessAlert.Yes) {
      // 「はい」がクリックされた場合は再度確認
      this.dialogService.openAlertGetMessage(
        'Q0145',
        null,
        (closeDetail) => {
          this.queryReleaseLockHandler(closeDetail);
        }
      );
    } else {
      // 「いいえ」がクリックされた場合(モード=REGISTでロック失敗時と同じ処理）
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, true);
      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode('true');
      }
      if (this.vo.faultFunc != null) {
        if (this.vo.faultFunc != null) {
          this.vo.faultFunc(this.vo.faultParam);
        }
      }
    }
  }

  public queryReleaseLockHandler(closeResult: number): void {
    if (closeResult === PlessAlert.Yes) {
      // 「はい」がクリックされた場合（モード=REGISTでロック成功時処理＋ロックの解除要求イベント発行）
      // ロック解除要求イベント発行
      this.vo.checkOnly = 'ReleaseAndRegist';
      this.lockType = 'ReleaseAndRegist';

      this.send('KYMW02registCatalogLock', this.getBodyRegist());

      // ここから モード=REGISTでロック成功時 と同じ処理
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, false);

      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode(this.model.kymw1001Model.setScreenModeOnNowFunc(this.model.kymw1001Model.topFuncID));
      }

      if (this.vo.successFunc != null) {
        this.vo.successFunc(this.vo.successParam);
      }
    } else {
      // 「いいえ」がクリックされた場合(モード=REGISTでロック失敗時と同じ処理）
      this.model.kymw1001Model.formReadOnlyMode.set(this.vo.viewHelper.popupView, true);
      if (this.vo.viewControl === true) {
        this.vo.viewHelper.setScreenMode('true');
      }
      if (this.vo.faultFunc != null) {
        this.vo.faultFunc(this.vo.faultParam);
      }
    }
  }

  private getMsgString(data: any): string {
    const dispNum: number = data.LockedUserDispNum;
    let planGoodsInfo: Array<any> = new Array<any>();
    let catalogInfo: Array<any> = new Array<any>();
    let pageInfo: Array<any> = new Array<any>();

    if (data.PlanGoods != null) {
      planGoodsInfo = data.PlanGoods;
    }

    if (data.Catalog != null) {
      catalogInfo = data.Catalog;
    }

    if (data.Page != null) {
      pageInfo = data.Page;
    }

    const tmpArray: Array<any> = new Array<any>();
    const msgArray: Array<any> = new Array<any>();

    let i: number;
    for (i = 0; i < planGoodsInfo.length; i++) {
      tmpArray.push(planGoodsInfo[i]);
    }
    for (i = 0; i < catalogInfo.length; i++) {
      tmpArray.push(catalogInfo[i]);
    }
    for (i = 0; i < pageInfo.length; i++) {
      tmpArray.push(pageInfo[i]);
    }

    tmpArray.sort(function (a, b) {
      if (a.UserId < b.UserId) {
        return -1;
      }
      if (a.UserId > b.UserId) {
        return 1;
      }
      return 0;
    });

    let msg = String('');
    let num = Number(0);
    let numZan = Number(0);
    let preUserId = String('');

    for (i = 0; i < tmpArray.length; i++) {
      if (tmpArray[i].UserId !== preUserId) {
        if (num < dispNum) {
          msg += '[' + PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(tmpArray[i].UserId), 1);
          if (PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(tmpArray[i].UserId), 1).length > 7) {
            msg += '\t';
          } else if (PlessViewUtilsSub.trimDirection(PlessViewUtilsSub.nullToBlank(tmpArray[i].UserId), 1).length > 4) {
            msg += '\t\t';
          } else {
            msg += '\t\t\t';
          }
          msg += PlessViewUtilsSub.nullToBlank(tmpArray[i].UserName) + ']\n';
        } else {
          numZan++;
        }
        num++;
        preUserId = tmpArray[i].UserId;
      }
    }

    msg += ',';
    if (numZan > 0) {
      msg += '他、' + numZan.toString() + '名';
    }

    return msg;
  }

}
